(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals() {
    var items = document.querySelectorAll('.ue-reveal:not(.ue-visible)');
    if (!items.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('ue-visible'); });
      return;
    }

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var delay = parseInt(entry.target.dataset.ueDelay || '0', 10);
          setTimeout(function () { entry.target.classList.add('ue-visible'); }, delay);
          obs.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    items.forEach(function (el) { obs.observe(el); });
  }

  function initContadores() {
    var nums = document.querySelectorAll('[data-ue-contador]:not([data-ue-hecho])');
    if (!nums.length) return;

    function pintar(el, valor) {
      el.textContent = (el.dataset.uePrefijo || '') + valor.toLocaleString('es-ES') + (el.dataset.ueSufijo || '');
    }

    if (reduce || !('IntersectionObserver' in window)) {
      nums.forEach(function (el) {
        el.dataset.ueHecho = '1';
        pintar(el, parseInt(el.dataset.ueContador, 10) || 0);
      });
      return;
    }

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          obs.unobserve(el);
          el.dataset.ueHecho = '1';
          var fin = parseInt(el.dataset.ueContador, 10) || 0;
          var inicio = performance.now();
          var dur = 1400;
          function paso(t) {
            var p = Math.min((t - inicio) / dur, 1);
            var e = 1 - Math.pow(1 - p, 3);
            pintar(el, Math.round(fin * e));
            if (p < 1) requestAnimationFrame(paso);
          }
          requestAnimationFrame(paso);
        });
      },
      { threshold: 0.4 }
    );

    nums.forEach(function (el) { obs.observe(el); });
  }

  function initFaq() {
    document.querySelectorAll('.ue-faq__btn:not([data-ue-listo])').forEach(function (btn) {
      btn.dataset.ueListo = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.ue-faq__item');
        var panel = item.querySelector('.ue-faq__panel');
        var abierto = item.classList.contains('ue-abierto');

        var lista = item.closest('.ue-faq__lista');
        if (lista && lista.dataset.ueSolo === 'true') {
          lista.querySelectorAll('.ue-faq__item.ue-abierto').forEach(function (otro) {
            if (otro === item) return;
            otro.classList.remove('ue-abierto');
            otro.querySelector('.ue-faq__panel').style.maxHeight = null;
            otro.querySelector('.ue-faq__btn').setAttribute('aria-expanded', 'false');
          });
        }

        item.classList.toggle('ue-abierto', !abierto);
        btn.setAttribute('aria-expanded', String(!abierto));
        panel.style.maxHeight = abierto ? null : panel.scrollHeight + 'px';
      });
    });
  }

  function initMenuMovil() {
    document.querySelectorAll('.ue-hamburguesa:not([data-ue-listo])').forEach(function (btn) {
      btn.dataset.ueListo = '1';
      btn.addEventListener('click', function () {
        var menu = document.getElementById(btn.dataset.ueObjetivo);
        if (!menu) return;
        var abierto = menu.classList.toggle('ue-abierto');
        btn.setAttribute('aria-expanded', String(abierto));
      });
    });
  }

  function initParallax() {
    if (reduce) return;
    var capas = document.querySelectorAll('[data-ue-parallax]');
    if (!capas.length) return;

    var pendiente = false;
    function actualizar() {
      pendiente = false;
      capas.forEach(function (capa) {
        var fuerza = parseFloat(capa.dataset.ueParallax) || 0;
        if (!fuerza) return;
        var caja = capa.getBoundingClientRect();
        if (caja.bottom < 0 || caja.top > window.innerHeight) return;
        var avance = (caja.top + caja.height / 2 - window.innerHeight / 2) / window.innerHeight;
        capa.style.transform = 'scale(1.12) translate3d(0,' + (avance * fuerza * 100).toFixed(2) + 'px,0)';
      });
    }

    window.addEventListener(
      'scroll',
      function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(actualizar);
      },
      { passive: true }
    );
    actualizar();
  }

  function initGaleria() {
    document.querySelectorAll('.ue-prod__galeria:not([data-ue-listo])').forEach(function (gal) {
      gal.dataset.ueListo = '1';
      var principal = gal.querySelector('.ue-prod__principal img');
      if (!principal) return;
      gal.querySelectorAll('.ue-prod__mini').forEach(function (mini) {
        mini.addEventListener('click', function () {
          var grande = mini.dataset.ueGrande;
          if (!grande) return;
          principal.src = grande;
          principal.srcset = '';
          gal.querySelectorAll('.ue-prod__mini').forEach(function (m) { m.classList.remove('ue-activa'); });
          mini.classList.add('ue-activa');
        });
      });
    });
  }

  function initVariantes() {
    document.querySelectorAll('.ue-prod__form[data-ue-variantes]:not([data-ue-listo])').forEach(function (form) {
      form.dataset.ueListo = '1';
      var datos = document.getElementById(form.dataset.ueVariantes);
      if (!datos) return;

      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }

      var selects = form.querySelectorAll('.ue-prod__select');
      var campoId = form.querySelector('input[name="id"]');
      var boton = form.querySelector('button[type="submit"]');
      var precio = document.querySelector('.ue-prod__precio');
      var tachado = document.querySelector('.ue-prod__tachado');
      if (!selects.length || !campoId) return;

      var etiqueta = boton.querySelector('span') || boton;

      function actualizar() {
        var elegidas = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = variantes.find(function (item) {
          return item.options.every(function (op, i) { return op === elegidas[i]; });
        });

        if (!v) {
          boton.disabled = true;
          etiqueta.textContent = form.dataset.ueAgotado || 'No disponible';
          return;
        }

        campoId.value = v.id;
        campoId.disabled = !v.available;
        boton.disabled = !v.available;
        etiqueta.textContent = v.available
          ? form.dataset.ueComprar || 'Comprar'
          : form.dataset.ueAgotado || 'Agotado';
        if (precio && v.price_txt) precio.textContent = v.price_txt;
        if (tachado) {
          tachado.textContent = v.compare_txt || '';
          tachado.style.display = v.compare_txt ? '' : 'none';
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', actualizar); });
      actualizar();
    });
  }

  function initTodo() {
    initReveals();
    initContadores();
    initFaq();
    initMenuMovil();
    initParallax();
    initGaleria();
    initVariantes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTodo);
  } else {
    initTodo();
  }

  document.addEventListener('shopify:section:load', initTodo);
})();
